module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticeHandsHips3.png
// module id = 2364
// module chunks = 2